<template>
  <div class="CommonPopup sup_switch--modal" id="Popup__formAdd1">
    <div class="Popup__overlay"></div>
    <div class="Popup__box">
      <div class="Popup__content">
        <div class="Popup__title">
          <h3>調整裝潢花費</h3>
        </div>
        <div class="Popup__paragraph">
          <div class="sup_switch--bars housemod">
            <div class="bars_text">
              <h4></h4>
              <p>{{ value | tenThousandCurrency }} <span>萬元</span></p>
            </div>
            <div class="bars1">
              <input type="range" id="bar"  :min="popValue.min" step="100000" :max="popValue.max" v-model.number="value">
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-xs-6 col-md-6 form-group" data-popup="BreakUp-close" @click="closeAddPopup('#Popup__formAdd1')">
            <div class="share_btn share_btn_peach" >
              <a href="#">取消</a>
            </div>
          </div>
          <div class="col-xs-6 col-md-6 form-group" data-popup="BreakUp-close" @click="updateData()">
            <div class="share_btn share_btn_peachDefault">
              <a href="" class="click_needs_analysis_tuneSpent_done">確定</a>
            </div>
          </div>
        </div>

        <div class="Popup__close" data-popup="BreakUp-close" @click="closeAddPopup('#Popup__formAdd1')">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "popup",
  props:{
    popValue: Object
  },
  data: function () {
    return {
      value: Number,
    }
  },
  methods: {
    closeAddPopup(popupId) {
      $(popupId).fadeOut(500)
    },
    openAddPopup(popupId) {
      $(popupId).fadeIn(500)
      this.setValue()
    },
    setValue() {
      this.value = store.get('buyHouse@postData.6')
    },
    updateData() {
      let value = this.value
      let token = this.$route.params.token
      store.dispatch('buyHouse/updateSBBuyHouseData', {value, token})
      this.closeAddPopup('#Popup__formAdd1')
    },
    setBarRange() {
      $(function () {
        var r = $('#bar');
        let max = (r[0].attributes.max.nodeValue)
        bg(r.val(), max);
        r.on('mouseenter', function () {
          var p = r.val();
          r.on('click', function () {
            p = r.val();
            bg(p, max);
          });
          r.on('mousemove', function () {
            p = r.val();
            bg(p, max);
          });
        });

        r.on('touchstart', function () {
          var p = r.val();
          r.on('click', function () {
            p = r.val();
          });
          r.on('touchmove', function () {
            p = r.val();
            bg(p, max);
          });
          r.on('touchend', function () {
            p = r.val();
            bg(p, max);
          });
        });
        function bg(n, max) {
          let v = (n*100 / max)
          $('#bar').css({
            'background-image': '-webkit-linear-gradient(left ,#EF8370 0%,#EF8370 ' + v + '%,#f2f2f2 ' + v + '%, #f2f2f2 100%)'
          });
        }
      });
    }
  },
  filters: {
    tenThousandCurrency(value) {
      var num = (Math.round(value/10000) || 0).toString(), result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-')
      return result;
    },
  },
  created() {
    this.setBarRange()
  }
}
</script>

<style scoped>

</style>